import { useState } from 'react'
import { ignitionPost } from '~/utils/ignitionFetch'

const submitForm = () => {
  const initialState = { loading: false, data: null, error: null }
  const [submission, setSubmission] = useState(initialState)

  const resetSubmission = () => {
    setSubmission(initialState)
  }

  const submitFormForService = (schema, formData, serviceId, childId, enrolment_token, guid) => {
    const body = {
      schema: schema,
      form_data: formData,
      service_id: serviceId
    }

    const generateUrl = childId => {
      if (enrolment_token) {
        return 'api/v1/enrolment-form'
      } else if (guid) {
        return `api/v1/re-enrolment/service/${serviceId}/save?guid=${guid}`
      } else if (childId) {
        return `api/v1/enrolment-form/service/${serviceId}/child/${childId}`
      }

      return `api/v1/enrolment-form/service/${serviceId}`
    }

    setSubmission({ loading: true })
    ignitionPost(generateUrl(childId), enrolment_token, body)
      .then(res => {
        setSubmission({ loading: null, data: res })

        if (window.parent) {
          window.parent.postMessage({ message: 'form-submitted' }, '*')
        }

        if (res && res.data.payment_form_url) {
          window.location.assign(res.data.payment_form_url)
        }
      })
      .catch(res => {
        setSubmission({
          loading: null,
          error: res.errors
            ? res.errors
            : 'An error occurred while submitting your enrolment form. Please try again.'
        })
      })
  }
  return [submission, submitFormForService, resetSubmission]
}
export default submitForm
